// @ts-nocheck
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Container, Alert } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import { useForm } from "../../../../../../context/FormContext";
import SaveSubmitButtons from "../../../../../../components/SaveSubmitButtons/SaveSubmitButtons";
import NotificationToast from "../../../../../../components/NotificationToast/NotificationToast";
import Topic from "./Topic";
import { getDocumentosByRespostaId } from "../../../../../../services";
import { salvarRespostaComArquivos } from "../../../../../../services/respostaService";
import "./DocBonusTab.css";
import { getHistoricoAnalise } from "../../../../../../services/analiseService";
import {
  enviarAdequacao,
  salvarAdequacao,
} from "../../../../../../services/adequacaoService";

export interface DocBonusTabProps {
  isActive?: boolean;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  resposta?: unknown;
  documentos?: unknown[];
  onProximo?: () => void;
  openByTopic?: Record<string, boolean>;
  onToggleOne?: (idCampoJson: string) => void;
  onTopicsLoaded?: (topics: { idCampoJson: string }[]) => void;
  showToggleAll?: boolean;
  isAllOpen?: boolean;
  onToggleAll?: () => void;
}

export interface DocBonusTabRefHandle {
  handleSave?: () => Promise<{ show?: boolean; message?: string; type?: string }>;
}

const DocBonusTab = forwardRef<DocBonusTabRefHandle, DocBonusTabProps>(
  (
    {
      isActive,
      setActiveTab,
      resposta,
      documentos,
      onProximo,
      openByTopic = {},
      onToggleOne,
      onTopicsLoaded,
      showToggleAll = false,
      isAllOpen = false,
      onToggleAll,
    },
    ref,
  ) => {
    const { updateFormData } = useForm();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedOptions, setSelectedOptions] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [topics, setTopics] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idResposta, setIdResposta] = useState(null);
    const [fullJson, setFullJson] = useState(null);
    const [, setPerfilUsuario] = useState({
      responsavelPreenchimento: "",
      cargoResponsavel: "",
    });
    const [toastData, setToastData] = useState({
      show: false,
      message: "",
      type: "",
    });
    const [formDisabled, setFormDisabled] = useState(false);
    const [showAdequacaoButton, setShowAdequacaoButton] = useState(false);
    const [historicoAnalise, setHistoricoAnalise] = useState<Record<string, unknown>>({});
    const [podeEditar, setPodeEditar] = useState(false);
    const [dataFim, setDataFim] = useState(false);
    const [receitaOperacional, setReceitaOperacional] = useState(0);
    const [dadosCadastros, setDadosCadastros] = useState();

    useImperativeHandle(ref, () => ({
      handleSave,
    }));

    useEffect(() => {
      if (!isActive || !resposta) return;

      setIsLoading(true);

      const rawJson = resposta.data?.json;
      const json = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;
      const id = resposta.data?.id;

      let respostaData = resposta.data;
      setDadosCadastros(respostaData);

      const temas = json?.docsBonus?.[0]?.tema || [];
      const temasFiltrados = temas.filter((tema) => {
        const titulo = tema.titulo?.trim().toUpperCase();
        return ![
          "7. EVOLUÇÃO RECEITA OPERACIONAL",
          "8. 80% DE RETENÇÃO DE ASSOCIADOS",
          "9. EVOLUÇÃO DO ASSOCIATIVISMO",
        ].includes(titulo);
      });

      const resolveReferenceLink = (titulo) => {
        const t = (titulo || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        if (t.includes("plano") && t.includes("negocio") && t.includes("sindical")) {
          return "https://docs.google.com/document/d/1vjm3cXjkbc36z61XiOQXOn8yId5EC7_U/edit";
        }
        return null;
      };

      const parsedTopics = temasFiltrados.map((tema, index) => {
        const tituloNormalizado = tema.titulo;

        return {
          id: index + 1,
          idCampoJson: tituloNormalizado,
          title: tema.titulo,
          description:
            tema.criterio?.find((c) => c?.titulo)?.titulo ||
            tema.criterio?.find((c) => c?.campo?.some((campo) => campo?.titulo))
              ?.campo?.[0]?.titulo ||
            tema.descricao ||
            "",
          criterios: tema.criterio || [],
          link: resolveReferenceLink(tema.titulo) || tema.link || null,
        };
      });

      const extrairNomeBase = (nomeArquivo) => {
        return nomeArquivo
          ?.toLowerCase()
          .replace(/-?\d{4}(-\d+)?/i, "")
          .replace(/-v\d+/i, "")
          .replace(/\.(pdf|xlsx)$/i, "")
          .trim();
      };

      const extrairVersao = (nomeArquivo) => {
        const match = nomeArquivo.match(/-v(\d+)/i);
        return match ? parseInt(match[1], 10) : 1;
      };

      const arquivosPorCampo = {};
      documentos?.forEach((doc) => {
        const nomeBase = extrairNomeBase(doc.nomeArquivo);
        const versao = extrairVersao(doc.nomeArquivo);

        if (!nomeBase) return;

        if (!arquivosPorCampo[nomeBase]) arquivosPorCampo[nomeBase] = [];

        arquivosPorCampo[nomeBase].push({ ...doc, versao });
      });

      const arquivosSelecionados = {};
      Object.entries(arquivosPorCampo).forEach(([campo, arquivos]) => {
        const arquivoMaisAtual = arquivos.sort(
          (a, b) => b.versao - a.versao
        )[0];
        arquivosSelecionados[campo] = [arquivoMaisAtual];
      });

      const extrairSelectedOptions = (json) => {
        const options = {};
        const temas = json?.docsBonus?.[0]?.tema || [];

        temas.forEach((tema, temaIdx) => {
          const topicId = temaIdx + 1;
          let respostaPrincipal = "";
          let caminhos = {};

          tema.criterio?.forEach((criterio) => {
            criterio.campo?.forEach((campo) => {
              if (campo.tipoCampo === "radio") {
                if (campo.resposta) respostaPrincipal = campo.resposta;
                campo.alternativa?.forEach((alt) => {
                  alt.campo?.forEach((subCampo) => {
                    if (subCampo.resposta)
                      caminhos[`${alt.valor}`] = subCampo.resposta;
                  });
                });
              }
            });
          });

          if (respostaPrincipal || Object.keys(caminhos).length > 0) {
            options[topicId] = {
              resposta: respostaPrincipal,
              caminhos,
            };
          }
        });

        return options;
      };

      const selected = extrairSelectedOptions(json);

      const carregarHistorico = async () => {
        try {
          const responseHistorico = await getHistoricoAnalise(id);

          const historico =
            responseHistorico?.historicoAnaliseAdequacaoCampoQuestionarioJson;

          if (Array.isArray(historico) && historico.length > 0) {
            const historicoMap = {};
            historico.forEach((item) => {
              if (item.idCampoJson) {
                historicoMap[item.idCampoJson] = {
                  ...item,
                  idCampoJson: item.idCampoJson,
                };
              }
            });
            setHistoricoAnalise(historicoMap);

            VerificarSePodeEditar(historicoMap);
          } else {
            setHistoricoAnalise({});
            VerificarSePodeEditar({});
          }
        } catch (error) {
          console.error("❌ Erro ao carregar histórico:", error);
          setHistoricoAnalise({});
          VerificarSePodeEditar({});
        }
      };

      const receitaOperacional = (() => {
        const docsObrigatorios = rawJson.docsObrigatorios?.[0]?.tema || [];

        for (const tema of docsObrigatorios) {
          for (const criterio of tema.criterio || []) {
            for (const campo of criterio.campo || []) {
              if (campo.idCampo === "DRE-receita-operacional") {
                return campo.resposta;
              }
            }
          }
        }

        return null;
      })();

      setTopics(parsedTopics);
      if (typeof onTopicsLoaded === "function") {
        onTopicsLoaded(parsedTopics);
      }
      setSelectedOptions(selected);
      setUploadedFiles(arquivosSelecionados);
      setReceitaOperacional(receitaOperacional);
      setIdResposta(id);
      setReceitaOperacional(receitaOperacional);
      setFullJson(json);
      setPerfilUsuario({
        responsavelPreenchimento: resposta.data?.responsavelPreenchimento || "",
        cargoResponsavel: resposta.data?.cargoResponsavel || "",
      });

      const normalizarTitulo = (titulo) => {
        let tituloNormalizado = titulo
          ?.toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

        if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
          tituloNormalizado = "dre-demonstracoes-do-resultado";
        }
        if (
          tituloNormalizado ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          tituloNormalizado =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return tituloNormalizado;
      };

      const VerificarSePodeEditar = (historico = null) => {
        try {
          const podeEditar = resposta.data.prazoEdicao;
          const datafim = resposta.data.dataFim;

          const rawJson = resposta.data?.json;
          const json =
            typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;

          const temas = json?.docsBonus?.[0]?.tema || [];
          const temasFiltrados = temas.filter((tema) => {
            const titulo = tema.titulo?.trim().toUpperCase();
            return ![
              "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL",
              "7. EVOLUÇÃO RECEITA OPERACIONAL",
              "8. 80% DE RETENÇÃO DE ASSOCIADOS",
              "9. EVOLUÇÃO DO ASSOCIATIVISMO",
            ].includes(titulo);
          });

          const slugsTemasPagina = temasFiltrados.map((t) =>
            normalizarTitulo(t.titulo)
          );

          const historicoMap = historico || historicoAnalise;

          const possuiAdequacaoNestaAba = Object.values(historicoMap).filter(
            (item) =>
              slugsTemasPagina.includes(normalizarTitulo(item.idCampoJson)) &&
              typeof item.dataSolicitacao === "string"
          );

          const temAdequacaoPendente = possuiAdequacaoNestaAba.some(
            (item) =>
              item.dataSolicitacao &&
              (!item.dataAdequacao || item.dataAdequacao === "")
          );

          if (temAdequacaoPendente) {
            setShowAdequacaoButton(true);
          } else {
            setShowAdequacaoButton(false);
          }

          const deveDesabilitar = !(podeEditar || datafim === null);
          setFormDisabled(deveDesabilitar);
          setPodeEditar(podeEditar);
          setDataFim(datafim);
        } catch (error) {
          console.error("Erro ao verificar se pode editar:", error);
        }
      };

      updateFormData("docBonus", {
        selectedOptions: selected,
        uploadedFiles: arquivosSelecionados,
      });

      carregarHistorico();
      VerificarSePodeEditar();
      setIsLoading(false);
    }, [isActive, resposta, documentos]);

    const handleOptionSelect = (topicId, option) => {
      const updatedOptions = {
        ...selectedOptions,
        [topicId]: option,
      };
      setSelectedOptions(updatedOptions);
      updateFormData("docBonus", {
        selectedOptions: updatedOptions,
        uploadedFiles,
      });
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[topicId];
        return newErrors;
      });
    };

    const handleFileUpload = (campoNomeArquivo, files) => {
      const updated = {
        ...uploadedFiles,
        [campoNomeArquivo]: files,
      };
      setUploadedFiles(updated);
      updateFormData("docBonus", {
        selectedOptions,
        uploadedFiles: updated,
      });
    };

    const updateRespostasNoJson = (json) => {
      const temasAtualizados = json.docsBonus?.[0]?.tema.map(
        (tema, temaIdx) => {
          const topicId = temaIdx + 1;
          const respostasTopico = selectedOptions[topicId] || {};
          const respostaPrincipal =
            typeof respostasTopico === "string"
              ? respostasTopico
              : respostasTopico.resposta;
          const caminhos = respostasTopico.caminhos || {};

          const atualizarCampos = (campos, path = []) =>
            campos?.map((campo) => {
              if (campo.tipoCampo === "radio") {
                const respostaCampo =
                  path.length === 0
                    ? respostaPrincipal
                    : caminhos[path.join(".")] || "";

                return {
                  ...campo,
                  resposta: respostaCampo,
                  alternativa: campo.alternativa?.map((alt) => {
                    if (alt.campo) {
                      const novaPath = [...path, alt.valor];
                      return {
                        ...alt,
                        campo: atualizarCampos(alt.campo, novaPath),
                      };
                    }
                    return alt;
                  }),
                };
              }

              return campo;
            });

          return {
            ...tema,
            criterio: tema.criterio?.map((criterio) => ({
              ...criterio,
              campo: atualizarCampos(criterio.campo),
            })),
          };
        }
      );

      return {
        ...json,
        docsBonus: [
          {
            ...json.docsBonus?.[0],
            tema: temasAtualizados,
          },
        ],
      };
    };

    const filtrarUltimaVersao = (documentos) => {
      const arquivosPorCampo = {};

      documentos.forEach((doc) => {
        const nomeBase = doc.nomeArquivo
          ?.toLowerCase()
          .replace(/-?\d{4}(-\d+)?/i, "")
          .replace(/-v\d+/i, "")
          .replace(/\.(pdf|xlsx)$/i, "")
          .trim();

        if (!nomeBase) return;

        const versaoMatch = doc.nomeArquivo.match(/-v(\d+)/i);
        const versao = versaoMatch ? parseInt(versaoMatch[1], 10) : 1;

        if (!arquivosPorCampo[nomeBase]) arquivosPorCampo[nomeBase] = [];

        arquivosPorCampo[nomeBase].push({ ...doc, versao });
      });

      const arquivosUltimaVersao = {};

      Object.keys(arquivosPorCampo).forEach((campo) => {
        const arquivos = arquivosPorCampo[campo];
        const arquivoMaisAtual = arquivos.sort(
          (a, b) => b.versao - a.versao
        )[0];
        arquivosUltimaVersao[campo] = [arquivoMaisAtual];
      });

      return arquivosUltimaVersao;
    };

    const handleAnalysisChange = (idCampoJson, valoresAtualizados) => {
      const normalizeIdCampoJson = (str) =>
        str
          ?.toString()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

      const key = normalizeIdCampoJson(idCampoJson);

      setHistoricoAnalise((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          ...valoresAtualizados,
          id: prev[key]?.id || 0,
          idCampoJson: key,
        },
      }));
    };

    const handleEnviarAdequacao = async () => {
      const rawJson = resposta.data?.json;
      const json = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;

      const temas = [
        ...(json?.docsObrigatorios?.[0]?.tema || []),
        ...(json?.docsBonus?.[0]?.tema || []),
        ...(json?.docsBonusExtra?.[0]?.tema || []),
      ];

      const temasFiltrados = temas.filter((tema) => {
        const titulo = tema.titulo?.trim().toUpperCase();
        return ![
          "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL",
          "7. EVOLUÇÃO RECEITA OPERACIONAL",
          "8. 80% DE RETENÇÃO DE ASSOCIADOS",
          "9. EVOLUÇÃO DO ASSOCIATIVISMO",
        ].includes(titulo);
      });

      const normalizarTitulo = (titulo) => {
        let tituloNormalizado = titulo
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^\w\s-]/g, "")
          .replace(/^\d+\s*[-.]*\s*/, "")
          .trim()
          .replace(/\s+/g, "-");

        if (tituloNormalizado === "dre---demonstracoes-do-resultado") {
          tituloNormalizado = "dre-demonstracoes-do-resultado";
        }

        if (
          tituloNormalizado ===
          "defesa-de-interesse-implementada-no-executivo-ou-legislativo"
        ) {
          tituloNormalizado =
            "defesa-de-interesse-implementada-no-executivo-e-legislativo";
        }

        return tituloNormalizado;
      };

      const slugsTemasPagina = temasFiltrados.map((t) =>
        normalizarTitulo(t.titulo)
      );

      const adequacoesRelevantes = Object.entries(historicoAnalise)
        .filter(([key, item]) => {
          const slugKey = normalizarTitulo(key);
          return (
            slugsTemasPagina.includes(slugKey) &&
            typeof item.dataSolicitacao === "string"
          );
        })
        .map(([_, item]) => item);

      const camposPendentes = adequacoesRelevantes.filter(
        (item) => item.adequacaoRealizada !== true
      );

      const todasAdequacoesMarcadas = adequacoesRelevantes.every(
        (item) => item.adequacaoRealizada === true
      );

      if (!todasAdequacoesMarcadas) {
        const camposFaltando = camposPendentes.map((item) => ({
          tema: item.tema,
          titulo: item.titulo || item.idCampoJson,
        }));

        setToastData({
          show: true,
          message: (
            <>
              <p>Você precisa marcar as adequações dos seguintes campos:</p>
              <ul style={{ marginTop: 6, marginBottom: 4, paddingLeft: 20 }}>
                {camposFaltando.map((campo, idx) => (
                  <li key={campo.titulo + idx} style={{ marginBottom: 4 }}>
                    <strong>{campo.tema ? campo.tema + ": " : ""}</strong>
                    <span style={{ textTransform: "capitalize" }}>
                      {campo.titulo.replace(/-/g, " ")}
                    </span>
                  </li>
                ))}
              </ul>
            </>
          ),
          type: "error",
        });
        return;
      }

      const adequacoesValidas = Object.values(historicoAnalise).filter(
        (item) =>
          (item.obsAnalista ||
            item.obsSindicato ||
            item.adequacaoRealizada !== undefined) &&
          item.id > 0
      );

      try {
        setLoading(true);

        const jsonAtualizado = {
          ...fullJson,
          receitaOperacional:
            receitaOperacional?.toString().trim() !== ""
              ? receitaOperacional
              : null,
          docsObrigatorios: [
            {
              ...fullJson?.docsObrigatorios?.[0],
              tema: fullJson?.docsObrigatorios?.[0]?.tema.map((tema, idx) => {
                const topicId = idx + 1;
                const respostasTopico = selectedOptions[topicId] || {};
                const camposPreenchidos = respostasTopico.campos || {};

                const atualizarCampos = (campos) =>
                  campos?.map((campo) => {
                    const campoKey =
                      campo.idCampo || campo.titulo?.replace(/\*/g, "").trim();
                    let respostaBruta =
                      camposPreenchidos[campoKey] ?? campo.resposta ?? "";
                    const respostaNormalizada =
                      respostaBruta?.toString().trim() === ""
                        ? null
                        : respostaBruta;

                    if (campo.tipoCampo === "radio") {
                      return {
                        ...campo,
                        resposta: respostaNormalizada,
                        alternativa: campo.alternativa?.map((alt) => {
                          if (alt.campo) {
                            return {
                              ...alt,
                              campo: atualizarCampos(alt.campo),
                            };
                          }
                          return alt;
                        }),
                      };
                    }

                    return {
                      ...campo,
                      resposta: respostaNormalizada,
                    };
                  });

                return {
                  ...tema,
                  criterio: tema.criterio?.map((criterio) => ({
                    ...criterio,
                    campo: atualizarCampos(criterio.campo),
                  })),
                };
              }),
            },
          ],
        };

        const receitaAtualizada = (() => {
          try {
            const temas = jsonAtualizado?.docsObrigatorios?.[0]?.tema || [];
            for (const tema of temas) {
              for (const criterio of tema.criterio || []) {
                for (const campo of criterio.campo || []) {
                  if (campo.idCampo === "DRE-receita-operacional") {
                    return campo.resposta;
                  }
                }
              }
            }
            return null;
          } catch (err) {
            console.error("❌ Erro ao extrair receitaAtualizada:", err);
            return null;
          }
        })();

        const arquivosParaEnvio = Object.values(uploadedFiles)
          .flat()
          .filter((file) => file instanceof File);

        const responsavelPreenchimento =
          localStorage.getItem("responsavelQuestionaro") || "";
        const cargoResponsavel = localStorage.getItem("cargoResponsavel") || "";

        await salvarRespostaComArquivos(
          idResposta,
          jsonAtualizado,
          receitaAtualizada,
          arquivosParaEnvio,
          {
            responsavelPreenchimento,
            cargoResponsavel,
          }
        );

        const payload = {
          Json: jsonAtualizado,
          ResponsavelPreenchimento: responsavelPreenchimento,
          CargoResponsavel: cargoResponsavel,
          ReceitaOperacional: receitaAtualizada,
          PercentualConclusao: 0,
          AdequacaoCamposQuestionarioJson: JSON.stringify(
            adequacoesValidas.map((item) => ({
              Id: item.id,
              ObsSindicato: item.obsSindicato || "",
              AdequacaoRealizada: item.adequacaoRealizada === true,
              IdCampoJson: item.idCampoJson,
              IdQuestionarioResposta: idResposta,
            }))
          ),
        };

        await enviarAdequacao(idResposta, payload);

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);
        setUploadedFiles(arquivosAtualizados);

        setToastData({
          show: true,
          message: "Adequação enviada com sucesso!",
          type: "success",
        });

        setTimeout(() => window.location.reload(), 500);
      } catch (error) {
        console.error("❌ Erro ao enviar adequação:", error);
        setToastData({
          show: true,
          message: "Erro ao enviar adequação!",
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    const handleSave = async () => {
      try {
        setLoading(true);

        const updatedJson = updateRespostasNoJson(fullJson);

        const receitaAtualizada = (() => {
          const temas = updatedJson?.docsObrigatorios?.[0]?.tema || [];
          for (const tema of temas) {
            for (const criterio of tema.criterio || []) {
              for (const campo of criterio.campo || []) {
                if (campo.idCampo === "DRE-receita-operacional") {
                  return campo.resposta;
                }
              }
            }
          }
          return null;
        })();

        const arquivosParaEnvio = Object.values(uploadedFiles)
          .flat()
          .filter((file) => file instanceof File);

        await salvarRespostaComArquivos(
          idResposta,
          updatedJson,
          receitaAtualizada,
          arquivosParaEnvio,
          {
            responsavelPreenchimento:
              dadosCadastros.responsavelPreenchimento || "",
            cargoResponsavel: dadosCadastros.cargoResponsavel || "",
          }
        );

        const emModoAdequacao = !!showAdequacaoButton;

        const adequacoesValidas = Object.values(historicoAnalise).filter(
          (item) =>
            (item.obsAnalista ||
              item.obsSindicato ||
              item.adequacaoRealizada !== undefined) &&
            item.id > 0
        );

        const payloadAdequacao = {
          Json:
            typeof updatedJson === "string"
              ? updatedJson
              : JSON.stringify(updatedJson),
          ResponsavelPreenchimento: dadosCadastros.responsavelPreenchimento,
          CargoResponsavel: dadosCadastros.cargoResponsavel,
          ReceitaOperacional: parseFloat(receitaAtualizada) || 0,
          PercentualConclusao: 0,
          AdequacaoCamposQuestionarioJson: JSON.stringify(
            adequacoesValidas.map((item) => ({
              Id: item.id,
              ObsSindicato: item.obsSindicato || "",
              AdequacaoRealizada: item.adequacaoRealizada === true,
              IdCampoJson: item.idCampoJson,
              IdQuestionarioResposta: idResposta,
            }))
          ),
          Arquivos: [],
        };

        if (emModoAdequacao && adequacoesValidas.length > 0) {
          await salvarAdequacao(idResposta, payloadAdequacao);
        }

        const documentosAtualizados = await getDocumentosByRespostaId(
          idResposta
        );
        const arquivosAtualizados = filtrarUltimaVersao(documentosAtualizados);

        setUploadedFiles(arquivosAtualizados);
        updateFormData("docBonus", {
          selectedOptions,
          uploadedFiles: arquivosAtualizados,
        });

        setToastData({
          show: true,
          message: "Documentos bônus salvos com sucesso!",
          type: "success",
        });

        return {
          show: true,
          message: "Documentos bônus salvos com sucesso!",
          type: "success",
        };
      } catch (error) {
        console.error("❌ Erro ao salvar documentos bônus:", error);
        setToastData({
          show: true,
          message: "Erro ao salvar os documentos bônus.",
          type: "error",
        });

        return {
          show: true,
          message: "Erro ao salvar os documentos bônus.",
          type: "error",
        };
      } finally {
        setLoading(false);
      }
    };

    const handleSubmit = async () => {
      const result = await handleSave();
      if (result?.type === "success") {
        onProximo();
      }
    };

    const _handleCancel = () => {
      setShowConfirmation(false);
    };

    const modoAdequacao = Object.values(historicoAnalise || {}).some(
      (item) =>
        typeof item?.dataSolicitacao === "string" &&
        item?.adequacaoRealizada !== true
    );

    return (
      <Container className="doc-bonus-container">
        {loading ? (
          <PageLoading minHeight="60vh" />
        ) : !showConfirmation ? (
          <>
            {!podeEditar && dataFim !== null && !showAdequacaoButton && (
              <Alert variant="warning" className="mt-3">
                Você não pode mais editar os dados de Documentos Obrigatórios.
              </Alert>
            )}

            <div className="shipping-tab-header">
              <h1 className="doc-bonus-title">DOCUMENTOS BÔNUS</h1>

              {showToggleAll && (
                <button
                  type="button"
                  className="shipping-toggle-all"
                  onClick={onToggleAll}
                  aria-label={isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                  title={
                    isAllOpen
                      ? "Recolher todos os tópicos"
                      : "Expandir todos os tópicos"
                  }
                >
                  {isAllOpen ? "Recolher tudo" : "Expandir tudo"}
                </button>
              )}
            </div>

            {isLoading ? (
              <PageLoading minHeight="60vh" />
            ) : (
              <>
                {topics.map((topic) => (
                  <Topic
                    key={topic.id}
                    data={topic}
                    onOptionSelect={handleOptionSelect}
                    onFileUpload={handleFileUpload}
                    hasError={!!errors[topic.id]}
                    idResposta={idResposta}
                    uploadedFiles={uploadedFiles}
                    selectedOptions={selectedOptions}
                    disabled={formDisabled}
                    modoAdequacao={modoAdequacao}
                    historico={historicoAnalise}
                    onAnalysisChange={handleAnalysisChange}
                    isOpen={openByTopic[topic.idCampoJson] === true}
                    onToggle={onToggleOne ? () => onToggleOne(topic.idCampoJson) : undefined}
                  />
                ))}
                <div className="buttons-container">
                  <SaveSubmitButtons
                    onSave={handleSave}
                    onSubmit={handleSubmit}
                    onAdequacaoSubmit={handleEnviarAdequacao}
                    podeEditar={podeEditar}
                    temAdequacao={showAdequacaoButton}
                  />
                </div>
                <NotificationToast
                  show={toastData.show}
                  onClose={() => setToastData((prev) => ({ ...prev, show: false }))}
                  message={toastData.message}
                  type={toastData.type}
                />
              </>
            )}
          </>
        ) : null}
      </Container>
    );
  }
);

export default DocBonusTab;